import React from 'react';
import { CheckIcon } from './icons/CheckIcon';
import { ArrowIcon } from './icons/ArrowIcon';
const problems = ['Querés ofrecer Hydra Lips o BB Lips, pero no sabés por dónde empezar.', 'Viste tutoriales en Instagram o YouTube, pero no te sentís lista para aplicarlo en clientas reales.', 'Te da miedo equivocarte, lastimar a alguien o que el resultado no sea profesional.', 'No sabés qué productos usar, cómo dosificar, ni cómo manejar complicaciones.', 'Querés cobrar bien por tu trabajo, pero no tenés la confianza ni la técnica para hacerlo.'];
export function PainPoints() {
  return <section className="py-12 px-4 bg-white" data-id="element-198">
      <div className="max-w-3xl mx-auto" data-id="element-199">
        <div className="mb-10" data-id="element-200">
          <img src="https://cdn.magicpatterns.com/uploads/iezvynYgfsroQf5AY9uu8y/ss_seen_on.png" alt="As seen on Glamour, Vogue, Marie Claire, Refinery29" className="w-full h-auto" data-id="element-201" />
        </div>

        <h2 className="text-xl md:text-2xl font-semibold text-[#3D3028] mb-8 text-center" data-id="element-202">
          Si hoy te sentís así, este Master es para vos
        </h2>

        <div className="bg-[#FAF8F4] rounded-2xl p-6 md:p-8 space-y-4" data-id="element-203">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-3" data-id="element-204">
              <div className="bg-[#E5A5A0]/10 p-1.5 rounded-full mt-0.5 flex-shrink-0" data-id="element-205">
                <CheckIcon className="w-3.5 h-3.5 text-[#E5A5A0]" data-id="element-206" />
              </div>
              <p className="text-[#3D3028]/80 text-sm md:text-base leading-snug" data-id="element-207">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="mt-6 bg-[#E5A5A0]/5 rounded-xl p-5 border-l-4 border-[#E5A5A0]" data-id="element-208">
          <div className="space-y-2" data-id="element-209">
            <div className="flex items-start gap-2" data-id="element-210">
              <ArrowIcon className="w-4 h-4 text-[#E5A5A0] mt-0.5 flex-shrink-0" data-id="element-211" />
              <p className="text-[#3D3028] font-medium text-sm" data-id="element-212">
                El problema no sos vos.
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-213">
              <ArrowIcon className="w-4 h-4 text-[#E5A5A0] mt-0.5 flex-shrink-0" data-id="element-214" />
              <p className="text-[#3D3028] font-medium text-sm" data-id="element-215">
                El problema es que nadie te dio una formación completa, guiada y
                profesional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}